import * as js from "./js-functions";
import * as web from "./web-functions";

export const fn = { js, web };
